const baseZendeskSupportReqUrl =
  "https://support.freshpaint.io/hc/en-us/requests/new";

/**
 * Builds a link to Freshpaint's Zendesk support request form with the
 * requester email, subject, and description fields pre-filled.
 *
 * @see https://support.zendesk.com/hc/en-us/articles/4408839114522-Creating-pre-filled-ticket-forms
 */
export function zendeskSupportLink(
  email: string,
  subject: string,
  body: string,
): string {
  return `${baseZendeskSupportReqUrl}?tf_anonymous_requester_email=${encodeURIComponent(
    email,
  )}&tf_subject=${encodeURIComponent(
    subject,
  )}&tf_description=${encodeURIComponent(body)}`;
}
